if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          this.form = this.querySelector('form');
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');

          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

          this.hideErrors = this.dataset.hideErrors === 'true';
        }

        onSubmitHandler(evt) {
          evt.preventDefault();

          const firstChecked = document.querySelector('variant-radios input[type="radio"][name="Size"]:checked');
          const sizes = document.querySelector('.js.product-form__input.hide .form__label');
          const title = document.querySelector('h1');
          const isGift = title.textContent.includes("Gift");
          // 👉 If size IS selected → STOP add to cart
          if (firstChecked == null && !sizes && !isGift) {
            const erroshow = document.querySelector('.size_select_error');

            if (erroshow) {
              erroshow.style.display = 'flex';
              erroshow.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
            }

            return; // ⛔ STOP execution here
          } else {
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            this.handleErrorMessage();

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            if (this.cart) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);

                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButton.querySelector('span').classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  });

                // Added to cart tracking(klaviyo)
                try {
                  window._learnq = window._learnq || [];
                  const variantId = Number(formData.get('id'));
                  let addedItem = null;

                  if (response.item) {
                    addedItem = response.item;
                  } else if (Array.isArray(response.items) && response.items.length) {
                    addedItem =
                      response.items.find((item) => Number(item.variant_id) === variantId) ||
                      response.items[response.items.length - 1];
                  } else {
                    addedItem = response;
                  }

                  if (!addedItem) {
                    console.log('No addedItem found in response:', response);
                    return;
                  } else {
                    console.log('Item is Added', addedItem);
                    window._learnq.push([
                      'track',
                      'Added to Cart',
                      {
                        $value: (addedItem.price / 100) * addedItem.quantity,
                        ProductID: addedItem.product_id,
                        VariantID: addedItem.variant_id,
                        Name: addedItem.product_title,
                        SKU: addedItem.sku,
                        Quantity: addedItem.quantity,
                        Price: addedItem.price / 100,
                        URL: window.location.origin + (addedItem.url || ''),
                        ImageURL: addedItem.image,
                      },
                    ]);
                  }
                } catch (e) {
                  console.error('Klaviyo Added to Cart tracking error', e);
                }
                // end Added to cart tracking

                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');
              });
          }
        }

        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage =
            this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  }